import { render, staticRenderFns } from "./insertReport.vue?vue&type=template&id=2fec03c1"
import script from "./insertReport.vue?vue&type=script&lang=js"
export * from "./insertReport.vue?vue&type=script&lang=js"
import style0 from "./insertReport.vue?vue&type=style&index=0&id=2fec03c1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports